import React from 'react'
import Form from './container'
import PageTemplate from 'components/page-template'

export default () => (
  <PageTemplate
    title='Create a Facebook Competition Experience'
    description="that's where automagic happens"
    className='br-experience widgetBuilder'
  >
    <Form experiencePlatform='facebook' />
  </PageTemplate>
)



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-competition/create/index.js